import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { PartialPreferences } from "./preferences";

export function usePreferencesFirestorePersistence(): usePreferencesFirestorePersistenceReturn {
  return useLazyContext(PreferencesFirestorePersistenceContext);
}

export type usePreferencesFirestorePersistenceReturn = {
  getPreferences: (userId: string) => Promise<PartialPreferences>;
  setPreferences: (
    userId: string,
    preferences: PartialPreferences,
  ) => Promise<void>;
};

export const PreferencesFirestorePersistenceContext =
  createContext<LazyValue<usePreferencesFirestorePersistenceReturn>>(undefined);
